<template>
  <div
    class="notification"
    :class="{
      'text-truncate': secondary,
      'w-100': detail
    }"
    :title="title"
    :type="notification.type"
  >

    <template v-if="detail">
      <slot v-if="!!$slots['detail-content'] || !!$slots.secondary" name="detail-content">
        <slot name="secondary"></slot>
      </slot>
    </template>

    <template v-else-if="actions || actionsSecondary">
      <slot name="actions">
        <slot name="actions-prepend" />
        <v-btn
          v-if="!notification.persistent"
          text
          small
          color="primary"
          @click="markRead">Gelesen</v-btn>
      </slot>
    </template>

    <template v-else>
      <slot name="primary">Unbekannte Benachrichtigung "{{notification.type}}"</slot>

      <small v-if="secondary && !!$slots.secondary">
        - <slot name="secondary" />
      </small>
    </template>
  </div>
</template>

<script>
  import {props as notificationProps, markRead} from './notification-utils';


  export default {
    name: 'NotificationText',

    props: notificationProps,

    data: () => ({
      title: ''
    }),

    watch: {
      secondary() {
        this.$nextTick(() => this._setTitle());
      }
    },

    mounted() {
      this.$nextTick(() => this._setTitle());
    },

    methods: {
      markRead() {
        markRead(this.notification);
      },

      _setTitle() {
        this.title = this.secondary ? this.$el.innerText : '';
      }
    }
  };
</script>

<style lang="scss" scoped>
  .notification {
    white-space: normal;
    word-break: break-word;
  }

  small {
    font-weight: normal !important;
  }
</style>
